import { useEffect, useRef, useState } from 'react';

export default function Services() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/2ffb9d5f69e4585252752a08fc5de7d3.jpeg',
      title: 'Esquadrias de Alumínio',
      description: 'Na hora de reformar ou construir a escolha das portas e janelas é uma decisão difícil. Além de combinar com a decoração, elas precisam estar adequadas ao projeto arquitetônico, sem deixar de ser práticas, seguras e funcionais.',
    },
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/2b874a03de7bb864f79ce120aed31ad8.png',
      title: 'Guarda-Corpo',
      description: 'Item fundamental para sacadas, varandas, escadas, mezaninos, entre outros. Para quem quer um guarda-corpo moderno e leve, o vidro é a melhor opção sem dúvidas!',
    },
    {
      image: 'https://public.readdy.ai/ai/img_res/39ebef8d8e852e1932bcc88f6c5f991c.jpg',
      title: 'Box',
      description: 'O box é muito importante para a organização do banheiro. Além da parte decorativa, ele é encarregado do bloqueio da água do chuveiro, mantendo um fácil escorrimento para o ralo.',
    },
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/7dca70b87dd5e3e271023e102bd11485.jpeg',
      title: 'Espelhos',
      description: 'São os detalhes que fazem a diferença! Os espelhos trazem personalidade e estilo aos ambientes. Na ALUMI INNOVA, você pode escolher o espelho ideal, com a moldura e os acabamentos que mais combinam com sua a casa.',
    },
  ];

  return (
    <section ref={sectionRef} id="servicos" className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-[#f8f9fa] to-[#e9ecef]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
          {/* Left Sticky Card */}
          <div className="lg:sticky lg:top-24 h-fit">
            <div className={`bg-white rounded-2xl shadow-xl p-6 md:p-8 lg:p-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="flex items-center space-x-4 mb-4 md:mb-6">
                <div className="h-1 w-12 md:w-16 bg-[#C0C0C0]"></div>
                <span className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide">
                  Para quem preza pela
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
                Qualidade
              </h2>

              <p className="text-sm md:text-base text-gray-700 mb-6 md:mb-8 leading-relaxed">
                A Alumi Innova é uma empresa que possui serviços de excelência no mercado. Com uma equipe especializada, trabalhamos com as melhores marcas do segmento, a fim de <strong>entregar sempre o melhor para os nossos clientes</strong>.
              </p>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-xl md:text-2xl text-[#C0C0C0]"></i>
                  <span className="text-sm md:text-base text-gray-800 font-medium">5 Anos de Garantia no alumínio</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-xl md:text-2xl text-[#C0C0C0]"></i>
                  <span className="text-sm md:text-base text-gray-800 font-medium">1 ano de garantia (acessório)</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-xl md:text-2xl text-[#C0C0C0]"></i>
                  <span className="text-sm md:text-base text-gray-800 font-medium">Vidros Certificados</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-xl md:text-2xl text-[#C0C0C0]"></i>
                  <span className="text-sm md:text-base text-gray-800 font-medium">Projetos Especiais</span>
                </div>
              </div>

              <button
                onClick={() => window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank')}
                className="w-full bg-[#C0C0C0] hover:bg-[#A8A8A8] text-[#010E31] font-semibold px-6 md:px-8 py-3 md:py-3.5 rounded-lg transition-all duration-300 inline-flex items-center justify-center space-x-2 whitespace-nowrap"
              >
                <span className="text-sm md:text-base">Solicitar Orçamento</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          {/* Right Services Grid */}
          <div className="space-y-4 md:space-y-6">
            {services.map((service, index) => (
              <div
                key={index}
                className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="grid md:grid-cols-5 gap-0">
                  <div className="md:col-span-2 h-48 md:h-auto w-full">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="md:col-span-3 p-4 md:p-6 lg:p-8 flex flex-col justify-center">
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                      {service.title}
                    </h3>
                    <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4 md:mb-6">
                      {service.description}
                    </p>
                    <button
                      onClick={() => window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank')}
                      className="self-start bg-[#010E31] hover:bg-[#C0C0C0] text-white hover:text-[#010E31] font-semibold px-4 md:px-6 py-2 md:py-2.5 rounded-lg transition-all duration-300 inline-flex items-center space-x-2 whitespace-nowrap text-sm md:text-base"
                    >
                      <span>Fazer Orçamento</span>
                      <i className="ri-arrow-right-circle-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
